// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * TicketV2 chat column only: bubble colors match TV2 mock (public / internal / customer).
 * Scoped under .ticketv2-ticket-chat so AuditTrail / status lines keep existing styling.
 */

/* "Ticket created by … via email" trail — continuous line with text break (Figma). */
.ticketv2-created-trail__line {
  flex: 1 1 auto;
  height: 1px;
  min-width: 24px;
  background: #e5e9ec;
  border: none;
}

.ticketv2-created-trail__text {
  box-shadow: 0 0 0 2px #fff;
  border-radius: 14px;
}

/* Composer row: global \`.ChatMessage_Container_Input\` is \`display:flex\` (row) without
   stretching the child, so the tv2 input box was shrink-wrapped (~40% width).
   Figma: 16px horizontal inset for chat column + composer. */
.ticketv2-ticket-chat .ChatMessage_Container_Input {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  flex-shrink: 0;
  align-items: stretch;
  overflow: visible;
  padding-left: 16px !important;
  padding-right: 16px !important;
}

/* Message thread: keep 16px content inset, but let the scrollbar sit on the
   column's right edge (same pattern as ChatV2 \`.MessageComponent-Main-02\`). */
.ticketv2-ticket-chat .TicketMessageComponent-Main-02 {
  padding: 0 !important;
  box-sizing: border-box;
  overflow: hidden;
}

.ticketv2-ticket-chat .TicketMessageComponent-Main-02 .scroll-wrapper {
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 16px 16px 0 !important;
  box-sizing: border-box;
}

.ticketv2-ticket-chat .TicketMessageComponent-Main-02 .scroll-wrapper::-webkit-scrollbar {
  width: 6px;
}

.ticketv2-ticket-chat .TicketMessageComponent-Main-02 .scroll-wrapper::-webkit-scrollbar-track {
  background: transparent;
}

.ticketv2-ticket-chat .TicketMessageComponent-Main-02 .scroll-wrapper::-webkit-scrollbar-thumb {
  background: #d5dce1;
  border-radius: 3px;
}

/* Allow emoji / canned popups to extend above the composer (parents use overflow: hidden). */
.ticketv2-ticket-chat.TicketMessageInput-Container-MainScreen {
  overflow: visible !important;
}

.ticketv2-ticket-chat .ChatMessageComponent-Container-Ticket {
  overflow: visible !important;
}

.ticketv2-ticket-chat .ChatMessage_Container_Input > * {
  flex: 1 1 auto;
  min-width: 0;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

.ticketv2-ticket-chat .ticket-message-content-wrapper {
  max-width: min(70%, 560px);
}

/* Customer (received) */
.ticketv2-ticket-chat .ticket-user-content {
  background-color: #f1f3f5 !important;
  color: #061522 !important;
}

/* Agent public reply */
.ticketv2-ticket-chat .ticket-agent-content {
  background-color: #d6edff !important;
  color: #061522 !important;
}

/* Internal note: header strip + divider + body (matches TV2 Figma) */
.ticketv2-ticket-chat .ticket-admin-content {
  background-color: #FFF1B8 !important;
  color: #061522 !important;
  padding: 0 !important;
  overflow: hidden;
  border-radius: 8px !important;
  box-shadow: 0 1px 2px 0 rgba(6, 21, 34, 0.05);
}

.ticketv2-ticket-chat .ticket-admin-content::before {
  content: "Internal Note";
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: #874D00;
  line-height: 1.2;
  font-family: "Inter", sans-serif;
  background: #FFF1B8;
  border-radius: 8px 8px 0 0;
  padding: 10px 16px;
  margin: 0;
  border-bottom: 1px solid #F3E1A6;
  box-sizing: border-box;
}

.ticketv2-ticket-chat .ticket-admin-content .ticket-message-text-container {
  padding: 10px 16px;
  box-sizing: border-box;
}

.ticketv2-ticket-chat .ticket-admin-content .ticket-image-container,
.ticketv2-ticket-chat .ticket-admin-content .ticket-attachments-container {
  padding-left: 12px;
  padding-right: 12px;
  box-sizing: border-box;
}

.ticketv2-ticket-chat .ticket-admin-content .ticket-message-time {
  padding: 0 12px 10px;
  box-sizing: border-box;
}

/* Links inside bubbles — override inline white from agent markdown */
.ticketv2-ticket-chat .ticket-agent-content .ticket-message-text a,
.ticketv2-ticket-chat .ticket-agent-content a {
  color: #148dfd !important;
}

.ticketv2-ticket-chat .ticket-user-content .ticket-message-text a,
.ticketv2-ticket-chat .ticket-user-content a {
  color: #007bff !important;
}

.ticketv2-ticket-chat .ticket-admin-content .ticket-message-text a,
.ticketv2-ticket-chat .ticket-admin-content a {
  color: #148dfd !important;
}

.ticketv2-ticket-chat .ticket-agent-time,
.ticketv2-ticket-chat .ticket-user-time {
  color: #8b97a2 !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/dashboardcomponents/TicketV2/ticketV2MessageOverrides.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF,qFAAqF;AACrF;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;;6DAE6D;AAC7D;EACE,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;8EAC8E;AAC9E;EACE,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,6FAA6F;AAC7F;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,wBAAwB;AACxB;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA,uBAAuB;AACvB;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA,qEAAqE;AACrE;EACE,oCAAoC;EACpC,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,6BAA6B;EAC7B,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;EACxB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,SAAS;EACT,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;;EAEE,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA,qEAAqE;AACrE;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B","sourcesContent":["/**\n * TicketV2 chat column only: bubble colors match TV2 mock (public / internal / customer).\n * Scoped under .ticketv2-ticket-chat so AuditTrail / status lines keep existing styling.\n */\n\n/* \"Ticket created by … via email\" trail — continuous line with text break (Figma). */\n.ticketv2-created-trail__line {\n  flex: 1 1 auto;\n  height: 1px;\n  min-width: 24px;\n  background: #e5e9ec;\n  border: none;\n}\n\n.ticketv2-created-trail__text {\n  box-shadow: 0 0 0 2px #fff;\n  border-radius: 14px;\n}\n\n/* Composer row: global `.ChatMessage_Container_Input` is `display:flex` (row) without\n   stretching the child, so the tv2 input box was shrink-wrapped (~40% width).\n   Figma: 16px horizontal inset for chat column + composer. */\n.ticketv2-ticket-chat .ChatMessage_Container_Input {\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n  flex-shrink: 0;\n  align-items: stretch;\n  overflow: visible;\n  padding-left: 16px !important;\n  padding-right: 16px !important;\n}\n\n/* Message thread: keep 16px content inset, but let the scrollbar sit on the\n   column's right edge (same pattern as ChatV2 `.MessageComponent-Main-02`). */\n.ticketv2-ticket-chat .TicketMessageComponent-Main-02 {\n  padding: 0 !important;\n  box-sizing: border-box;\n  overflow: hidden;\n}\n\n.ticketv2-ticket-chat .TicketMessageComponent-Main-02 .scroll-wrapper {\n  height: 100%;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 16px 16px 0 !important;\n  box-sizing: border-box;\n}\n\n.ticketv2-ticket-chat .TicketMessageComponent-Main-02 .scroll-wrapper::-webkit-scrollbar {\n  width: 6px;\n}\n\n.ticketv2-ticket-chat .TicketMessageComponent-Main-02 .scroll-wrapper::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.ticketv2-ticket-chat .TicketMessageComponent-Main-02 .scroll-wrapper::-webkit-scrollbar-thumb {\n  background: #d5dce1;\n  border-radius: 3px;\n}\n\n/* Allow emoji / canned popups to extend above the composer (parents use overflow: hidden). */\n.ticketv2-ticket-chat.TicketMessageInput-Container-MainScreen {\n  overflow: visible !important;\n}\n\n.ticketv2-ticket-chat .ChatMessageComponent-Container-Ticket {\n  overflow: visible !important;\n}\n\n.ticketv2-ticket-chat .ChatMessage_Container_Input > * {\n  flex: 1 1 auto;\n  min-width: 0;\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n}\n\n.ticketv2-ticket-chat .ticket-message-content-wrapper {\n  max-width: min(70%, 560px);\n}\n\n/* Customer (received) */\n.ticketv2-ticket-chat .ticket-user-content {\n  background-color: #f1f3f5 !important;\n  color: #061522 !important;\n}\n\n/* Agent public reply */\n.ticketv2-ticket-chat .ticket-agent-content {\n  background-color: #d6edff !important;\n  color: #061522 !important;\n}\n\n/* Internal note: header strip + divider + body (matches TV2 Figma) */\n.ticketv2-ticket-chat .ticket-admin-content {\n  background-color: #FFF1B8 !important;\n  color: #061522 !important;\n  padding: 0 !important;\n  overflow: hidden;\n  border-radius: 8px !important;\n  box-shadow: 0 1px 2px 0 rgba(6, 21, 34, 0.05);\n}\n\n.ticketv2-ticket-chat .ticket-admin-content::before {\n  content: \"Internal Note\";\n  display: block;\n  font-size: 12px;\n  font-weight: 600;\n  color: #874D00;\n  line-height: 1.2;\n  font-family: \"Inter\", sans-serif;\n  background: #FFF1B8;\n  border-radius: 8px 8px 0 0;\n  padding: 10px 16px;\n  margin: 0;\n  border-bottom: 1px solid #F3E1A6;\n  box-sizing: border-box;\n}\n\n.ticketv2-ticket-chat .ticket-admin-content .ticket-message-text-container {\n  padding: 10px 16px;\n  box-sizing: border-box;\n}\n\n.ticketv2-ticket-chat .ticket-admin-content .ticket-image-container,\n.ticketv2-ticket-chat .ticket-admin-content .ticket-attachments-container {\n  padding-left: 12px;\n  padding-right: 12px;\n  box-sizing: border-box;\n}\n\n.ticketv2-ticket-chat .ticket-admin-content .ticket-message-time {\n  padding: 0 12px 10px;\n  box-sizing: border-box;\n}\n\n/* Links inside bubbles — override inline white from agent markdown */\n.ticketv2-ticket-chat .ticket-agent-content .ticket-message-text a,\n.ticketv2-ticket-chat .ticket-agent-content a {\n  color: #148dfd !important;\n}\n\n.ticketv2-ticket-chat .ticket-user-content .ticket-message-text a,\n.ticketv2-ticket-chat .ticket-user-content a {\n  color: #007bff !important;\n}\n\n.ticketv2-ticket-chat .ticket-admin-content .ticket-message-text a,\n.ticketv2-ticket-chat .ticket-admin-content a {\n  color: #148dfd !important;\n}\n\n.ticketv2-ticket-chat .ticket-agent-time,\n.ticketv2-ticket-chat .ticket-user-time {\n  color: #8b97a2 !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
